var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.currentMenu === 'admin')?_c('AdminMenu'):(_vm.currentMenu === 'user')?_c('UserMenu'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }